export const PORTAL_FEATURE_DISCOVERY_CATEGORY = 'portal feature discovery';
